<template>
  <div class="notice-list mt20" v-if="getworkDynamicsList.list.length">
    <el-tabs class="el-tabs__customize" v-model="tabName">
      <el-tab-pane :label="getworkDynamicsList.label" name="first">
        <div class="workDynamics">
          <ul>
            <li
              v-for="item2 in getworkDynamicsList.list"
              class="ellipsis ccui-clearfix"
              :key="item2.id"
              @click="handleOp(item2)"
            >
              <img :src="item2.imgUrl" alt="" />
              <p>{{ item2.title }}</p>
            </li>
            <li
              v-for="item2 in 12 - getworkDynamicsList.list.length"
              class="ellipsis ccui-clearfix"
              style="background-color: #F2F7FC;"
              :key="item2"
            ></li>
          </ul>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { updateAdvHits } from "../api/shopping";
export default {
  name: "noticeList1",
  props: ["workDynamicsList"],
  data() {
    return {
      tabName: "first",
      nodeList: [],
      agentIdEncrypt: ""
    };
  },
  computed: {
    getworkDynamicsList() {
      return this.workDynamicsList;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
    handleOp(row) {
      if (row.linkUrl) {
        updateAdvHits({
          advInfoId: row.id
        });
        window.open(row.linkUrl, "_blank");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.mt20 {
  margin-top: 4px;
}
.notice-list {
  // height: 230px;
  width: 100%;
  position: relative;
  .notice-list-tabs {
    padding: 0 15px;
  }
  .notice-list-view-all {
    position: absolute;
    right: 15px;
    top: 20px;
    line-height: 18px;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #999999;
    &:hover {
      color: #0089ef;
    }
  }
  /deep/ .el-tabs__content .el-tab-pane {
    /*height: 175px;*/
    overflow: hidden;
  }
}
/deep/ .el-tabs__active-bar {
  display: none;
}
/deep/ .el-tabs__item.is-active {
  color: #4a4a4a;
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
  font-family: PingFangSC, PingFang SC;
}
/deep/ .el-tabs__item {
  cursor: unset;
}
.workDynamics {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: hidden;
  ul {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      cursor: pointer;
      width: 180px;
      height: 180px;
      margin-bottom: 20px;
      background: #ffffff;
      img {
        margin: 16px 25px 0px 25px;
        width: 130px;
        height: 130px;
      }
      p {
        // width: 64px;
        height: 22px;
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-size: 16px;
        color: #4a4a4a;
        line-height: 22px;
        text-align: center;
        // margin-bottom: 8px;
      }
    }
  }
}
/deep/ .el-tabs__header {
  margin-bottom: 16px;
  height: 32px !important;
  line-height: 32px !important;
  padding-top: 4px;
}
.icon-notice-list {
  position: absolute;
  left: 20px;
  top: 16px;
  color: #0089ef;
}
</style>
